"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformProjectLayerSet = void 0;
const TransformObject_1 = require("./TransformObject");
class TransformProjectLayerSet extends TransformObject_1.TransformObject {
    constructor(parent, baseLayerSet) {
        super(parent, {
            baseLayerSet,
        }, baseLayerSet.id, new Set());
    }
    static From(parent, other) {
        return new TransformProjectLayerSet(parent, other.compiled);
    }
    compile() {
        return this._sharedData.baseLayerSet;
    }
}
exports.TransformProjectLayerSet = TransformProjectLayerSet;
//# sourceMappingURL=TransformProjectLayerSet.js.map